export default __webpack_public_path__ + "static/media/23.ce0cc75d.png";